import { __assign, __spreadArrays } from "tslib";
import React, { useContext, useMemo } from 'react';
import { CommentContext } from '../CommentContext';
import { sortPapiBadge } from '../../../coreBadge/utils';
import { ResourceType } from '../../../types/resource';
import Badge from '../../../Badge';
import Flex from '../../../Flex';
import CoreBadgeButton from '../../../coreBadge/CoreBadgeButton';
import { BiEventType } from '../../../biLogger/constants';
import CustomNotificationProvider from '../../../Notifications/CustomNotificationContext';
import { getCommentNotificationQueue } from '../../utils';
import PopoverNotification from '../../../Notifications/PopoverNotification';
import { NotificationType } from '../../../Notifications';
import s from './CommentBadges.scss';
var CommentBadges = function (_a) {
    var className = _a.className;
    var comment = useContext(CommentContext).comment;
    var badges = useMemo(function () {
        var sorted = __spreadArrays(comment.awardedBadges);
        sorted.sort(sortPapiBadge);
        return sorted;
    }, [comment.awardedBadges]);
    return (React.createElement(CustomNotificationProvider, { queueName: getCommentNotificationQueue(comment) },
        React.createElement(Flex, { className: className }, badges.map(function (badge) {
            return badge.stackCount && (React.createElement(CoreBadgeButton, { className: s['badge-button'], key: badge.name, type: badge.name, badges: badges, recipient: {
                    typeId: ResourceType.COMMENT,
                    itemId: comment.commentId,
                    user: comment.user,
                }, biData: {
                    evid: BiEventType.BADGE_STATISTICS_CLICK,
                    sectionname: 'comments',
                    typeid: ResourceType.COMMENT,
                    itemid: comment.commentId,
                } },
                React.createElement(PopoverNotification, { contentClassName: s['notification'], notificationTypes: [NotificationType.Badge], notificationFilter: function (notification) { var _a, _b; return ((_b = (_a = notification.params) === null || _a === void 0 ? void 0 : _a.badge) === null || _b === void 0 ? void 0 : _b.name) === badge.name; } },
                    React.createElement(Badge, __assign({ className: s['badge'] }, badge)),
                    " ",
                    badge.stackCount)));
        }))));
};
CommentBadges.displayName = 'CommentBadges';
export default CommentBadges;
//# sourceMappingURL=CommentBadges.js.map